import { useEffect, useRef } from "react";
import { trackEvent } from "@/lib/analytics";

export const adKeyOf = (ad, idx) => ad.id || ad.url || `ad-${idx}`;

// Logs one banner_ad_view per ad per page session, only while the ads section is on screen.
export function useAdViewTracking(api, ads, sectionRef) {
  const seen = useRef(new Set());
  const visible = useRef(false);

  useEffect(() => {
    if (!api || !ads.length) return undefined;
    const record = () => {
      if (!visible.current) return;
      const idx = api.selectedScrollSnap();
      const ad = ads[idx];
      if (!ad) return;
      const key = adKeyOf(ad, idx);
      if (seen.current.has(key)) return;
      seen.current.add(key);
      trackEvent("banner_ad_view", { adId: key, adIndex: idx });
    };
    const node = sectionRef.current;
    let obs;
    if (node && typeof IntersectionObserver !== "undefined") {
      obs = new IntersectionObserver(
        ([entry]) => {
          visible.current = entry.isIntersecting && entry.intersectionRatio >= 0.5;
          record();
        },
        { threshold: [0, 0.5] }
      );
      obs.observe(node);
    }
    api.on("select", record);
    return () => {
      api.off("select", record);
      obs?.disconnect();
    };
  }, [api, ads, sectionRef]);
}
